"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preQualifiersConfig = exports.medicalConditions = exports.liveInUk = exports.hiv = exports.heightWeight = exports.drugs = exports.age = exports.QualifierDefinition = exports.PreQualifiersDefinition = void 0;

var _QualifierContent = require("./Qualifier/QualifierContent");

var _field = require("../../types/field");

var _types = require("../../types");

var _config = require("../config");

var _heightWeightConfig = require("../HeightWeight/heightWeightConfig");

var _radioConfig = require("../../fields/Radio/radioConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _radioConfig.RadioDefinition;
});

var HeightWeightDefinition = _flowRuntime["default"].tdz(function () {
  return _heightWeightConfig.HeightWeightDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var FieldInfoDefinition = _flowRuntime["default"].tdz(function () {
  return _field.FieldInfoDefinition;
});

var QualifierDefinition = _flowRuntime["default"].type("QualifierDefinition", _flowRuntime["default"].object(_flowRuntime["default"].property("radio", _flowRuntime["default"].ref(RadioDefinition)), _flowRuntime["default"].property("label", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("failContent", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("desiredAnswer", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("otherAnswer", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("info", _flowRuntime["default"].ref(FieldInfoDefinition), true)));

exports.QualifierDefinition = QualifierDefinition;
var age = {
  radio: {
    key: 'age',
    title: 'Are you aged between 16-30?',
    type: 'radio',
    description: 'If you’re accepted onto the register you will remain on it until your 61st birthday.',
    normalize: 'boolean',
    items: [{
      key: 'ageYes',
      label: 'Yes',
      value: 'true',
      classes: 'control control--radio yes-no btn btn--primary btn--medium right-arrow'
    }, {
      key: 'ageNo',
      label: 'No',
      value: 'false',
      classes: 'control control--radio yes-no btn btn--secondary btn--medium'
    }],
    validation: [{
      required: true
    }, {
      failValue: {
        value: false,
        errorMsg: 'You cannot progress if your answer to this question is No'
      }
    }]
  },
  desiredAnswer: 'Yes',
  otherAnswer: 'No',
  failContent: _QualifierContent.ageFailHTML,
  info: {
    text: 'We recruit people to the register between the age of 16 and 30 because hospitals are most likely to choose people in this age group as donors.',
    title: 'Why we need to ask you this'
  }
};
exports.age = age;
var liveInUk = {
  radio: {
    key: 'liveInUk',
    title: 'Do you live in the UK?',
    type: 'radio',
    description: 'Including the Channel Islands',
    normalize: 'boolean',
    items: [{
      key: 'ukYes',
      label: 'Yes',
      value: 'true',
      classes: 'control control--radio yes-no btn btn--primary btn--medium right-arrow'
    }, {
      key: 'ukNo',
      label: 'No',
      value: 'false',
      classes: 'control control--radio yes-no btn btn--secondary btn--medium'
    }],
    validation: [{
      required: true
    }, {
      failValue: {
        value: false,
        errorMsg: 'You cannot progress if your answer to this question is No'
      }
    }]
  },
  desiredAnswer: 'Yes',
  otherAnswer: 'No',
  failContent: _QualifierContent.ukFailHTML,
  info: {
    text: 'Anthony Nolan is a UK donor registry. This means we can only sign up potential donors who live in the UK so they are easily contactable and available to come to transplant centres if they were ever found to be a match.',
    title: 'Why we need to ask you this'
  }
};
exports.liveInUk = liveInUk;
var hiv = {
  radio: {
    key: 'hiv',
    type: 'radio',
    title: 'Have you or your partner ever had a positive result for HIV, HTLV, Hepatitis B or Hepatitis C?',
    normalize: 'boolean',
    items: [{
      key: 'hivYes',
      label: 'Yes',
      value: 'true',
      classes: 'control control--radio yes-no btn btn--secondary btn--medium'
    }, {
      key: 'hivNo',
      label: 'No',
      value: 'false',
      classes: 'control control--radio yes-no btn btn--primary btn--medium right-arrow'
    }],
    validation: [{
      required: true
    }, {
      failValue: {
        value: true,
        errorMsg: 'You cannot progress if your answer to this question is Yes'
      }
    }]
  },
  desiredAnswer: 'No',
  otherAnswer: 'Yes',
  failContent: _QualifierContent.hivFailHTML
};
exports.hiv = hiv;
var drugs = {
  radio: {
    key: 'drugs',
    title: 'Have you ever been injected with non-prescription drugs, including body-building drugs (includes one off use)?',
    type: 'radio',
    normalize: 'boolean',
    items: [{
      key: 'drugsYes',
      label: 'Yes',
      value: 'true',
      classes: 'control control--radio yes-no btn btn--secondary btn--medium'
    }, {
      key: 'drugsNo',
      label: 'No',
      value: 'false',
      classes: 'control control--radio yes-no btn btn--primary btn--medium right-arrow'
    }],
    validation: [{
      required: true
    }, {
      failValue: {
        value: true,
        errorMsg: 'You cannot progress if your answer to this question is Yes'
      }
    }]
  },
  desiredAnswer: 'No',
  otherAnswer: 'Yes',
  failContent: _QualifierContent.drugFailHTML
};
exports.drugs = drugs;
var medicalConditions = {
  radio: {
    key: 'medicalConditions',
    title: 'Have you ever been diagnosed with any of the following medical conditions?',
    type: 'radio',
    description: _QualifierContent.conditionsHTML,
    normalize: 'boolean',
    items: [{
      key: 'medYes',
      label: 'Yes',
      value: 'true',
      classes: 'control control--radio yes-no btn btn--secondary btn--medium'
    }, {
      key: 'medNo',
      label: 'No',
      value: 'false',
      classes: 'control control--radio yes-no btn btn--primary btn--medium right-arrow'
    }],
    validation: [{
      required: true
    }, {
      failValue: {
        value: true,
        errorMsg: 'You cannot progress if your answer to this question is Yes'
      }
    }]
  },
  desiredAnswer: 'No',
  otherAnswer: 'Yes',
  failContent: _QualifierContent.medFailHTML
};
exports.medicalConditions = medicalConditions;
var heightWeight = {
  key: 'heightWeight',
  type: 'heightWeight',
  info: {
    title: 'Why we need to ask you for your height and weight',
    text: 'Providing your height and weight is really important to make sure it’s okay for you to join the register, and to help us when looking for potential donors. You might not know it off the top of your head, but we’d love for you to go and find out!'
  },
  validation: [{
    maxBmi: 40
  }, {
    minWeight: 50
  }]
};
exports.heightWeight = heightWeight;
var preQualifiersConfig = {
  type: 'preQualifiers',
  subComponents: [heightWeight],
  fields: [age.radio, liveInUk.radio, hiv.radio, drugs.radio, medicalConditions.radio]
};
exports.preQualifiersConfig = preQualifiersConfig;

var PreQualifiersDefinition = _flowRuntime["default"].type("PreQualifiersDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("preQualifiers")), _flowRuntime["default"].property("options", _flowRuntime["default"].object(_flowRuntime["default"].property("age", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("liveInUk", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("heightWeight", _flowRuntime["default"].object(_flowRuntime["default"].property("height", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("weight", _flowRuntime["default"]["boolean"]()))), _flowRuntime["default"].property("hiv", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("drugs", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("medicalConditions", _flowRuntime["default"]["boolean"]()))))));

exports.PreQualifiersDefinition = PreQualifiersDefinition;